module.exports = __webpack_public_path__ + "static/media/person01.979b7c7f.png";